import Component from '../core/Component'

const DEFAULT = 'Vybrat soubor ...'

export default class FileInput extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            filename: null,
            input: null
        }
    }

    prepare() {
        this.ref.input.addEventListener('change', ::this.handleChange)
    }

    handleChange(event) {
        if (!event.target.value) {
            this.ref.filename.innerHTML = DEFAULT
        } else {
            this.ref.filename.innerHTML = event.target.value.split(/(\\|\/)/g).pop()
        }
    }
}